import withWindowDimensions from 'components/common/withWindowDimensions'
import Button from 'components/LSRevamp/common/Button'
import { counsellingStageRank } from 'DataMapper/Profile/StageMapper'
import { logEvent } from 'ga'
import { AuthToken } from 'lib/auth_token'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { navRoutes } from 'page_routes'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { trackClick } from 'scripts/segment'
import { pageName } from 'utils/events-utils'

interface Props {
  isMobileSized?: boolean
}

const CounsellorsHeroComponent: React.FC<Props> = ({ isMobileSized }) => {
  const counsellingStage = useSelector(
    (state: any) => state.spotCounselling.stage,
  )
  const authValue = useSelector((state: any) => state?.auth?.auth?.token)
  const authToken = new AuthToken(authValue)
  const isLoggedIn = authToken && authToken.isValid
  const router = useRouter()

  const [heroCtaText, setHeroCtaText] = useState('Start your Journey')

  // TODO:: need to abstract this logic to some hoc or hook
  useEffect(() => {
    if (isLoggedIn) {
      if (counsellingStageRank[counsellingStage as string] <= 2) {
        setHeroCtaText('Start your Journey')
      } else {
        setHeroCtaText('Get Access')
      }
    } else {
      setHeroCtaText('Start your Journey')
    }
  }, [isLoggedIn, counsellingStage])

  const handleClick = () => {
    if (isLoggedIn) {
      if (counsellingStageRank[counsellingStage as string] <= 2) {
        logEvent('Get Expert Counselling', router.asPath, 'Banner')
        router.push(navRoutes.WEBFLOW_PROGRESSIVE_FORM)
      } else {
        logEvent('Get Access', router.asPath, 'Banner')
        router.push(navRoutes.POSTLOGIN_COUNSELLING)
      }
    } else {
      router.push(navRoutes.WEBFLOW_PROGRESSIVE_FORM)
    }
  }
  return (
    <div className="text-white bg-gradient-to-r from-[#102077] to-[#49138C]">
      <h1 className="text-[32px] text-center md:text-5xl px-3.5 lg:px-[290px]  pt-5 md:pt-[79px] leading-[43px] md:leading-[59px]">
        Connect with India’s Top Counsellors
      </h1>

      <h3 className="text-center text-base sm:text-[22px] pl-12 pr-[33px] mt-3.5 lg:px-[344px] text-[#DADADA] leading-[22.5px] md:leading-[30px] ">
        Hear from our Top Students and their success story to a global career!
      </h3>

      <div className="flex flex-row items-center justify-center ">
        {!isMobileSized ? (
          <div className=" self-end md:mt-[36.96px] md:mb-[-7px]">
            <Image
              src="https://ik.imagekit.io/onsnhxjshmp/counsellors_group_photo_uwc2cvjts.png"
              width={709.86}
              height={412.93}
              priority={true}
              alt={'group-photo'}
            />
          </div>
        ) : null}

        <div className="flex flex-col justify-center items-center  md:ml-[46px] md:mb-[104px] w-[318px] md:w-[364px] ">
          <div className="flex flex-row w-full justify-evenly items-center mt-[34px]">
            <h5 className="flex flex-col">
              <h5 className="text-lg sm:text-2xl font-semibold text-center">
                {'<'} 2 minutes
              </h5>

              <h5 className="text-sm sm:text-base text-[#B5B5B5]">
                to meet your counsellor
              </h5>
            </h5>

            <div className="m-2.5">
              <Image
                src= {`${process.env.CDN_URL}/assets/images/LSRevamp/Line-151.svg`}
                width={1}
                height={isMobileSized ? 38 : 44}
                alt={'line'}
              />
            </div>

            <h5 className="flex flex-col ">
              <h5 className="text-lg sm:text-2xl font-semibold text-center">
                1500+
              </h5>

              <h5 className="text-sm sm:text-base text-[#B5B5B5]">
                Experts to help you
              </h5>
            </h5>
          </div>

          {!isMobileSized ? (
            <div className="mt-[31px] font-bold rounded">
              <Button
                trackingEvent={() => {
                  trackClick(pageName.CounsellorPage, {
                    contentName: 'Start your Journey',
                    widgetName: 'Hero',
                    widgetFormat: 'Banner',
                    contentFormat: 'Button',
                  })
                }}
                text={heroCtaText}
                color="text-white"
                backgroundColor="bg-yellow-to-orange"
                width="w-[255px]"
                handleSpotCounsellingFlow={handleClick}
                border="border-0"
              />
            </div>
          ) : null}
        </div>
      </div>
      {isMobileSized ? (
        <>
          <div className="text-center mt-[19px] ">
            <Image
              src="https://ik.imagekit.io/onsnhxjshmp/counsellors_group_photo_uwc2cvjts.png"
              width={323.07}
              height={187.93}
              priority={true}
              alt={'group-photo'}
            />
          </div>
          <div className="mt-[22px] font-bold  text-center text-sm pb-[49px]">
            <Button
              trackingEvent={() => {
                trackClick(pageName.CounsellorPage, {
                  contentName: 'Start your Journey',
                  widgetName: 'Hero',
                  widgetFormat: 'Banner',
                  contentFormat: 'Button',
                })
              }}
              text={heroCtaText}
              color="text-white"
              backgroundColor="bg-yellow-to-orange"
              width="w-[255px]"
              handleSpotCounsellingFlow={handleClick}
              border="border-0"
            />
          </div>{' '}
        </>
      ) : null}
    </div>
  )
}

export default withWindowDimensions(CounsellorsHeroComponent)
